import { render } from "./accounts.vue?vue&type=template&id=6da555cb"
import script from "./accounts.vue?vue&type=script&lang=ts"
export * from "./accounts.vue?vue&type=script&lang=ts"
script.render = render

export default script